export const DELAY_BRANDS = 50
export const DELAY_CLOSE_MENU = 300
export const DELAY_DELAY_BACK_ACTION = 100
export const DELAY_ENTRIES = 50
export const DELAY_OUTSIDE = 50
export const DELAY_TIME_PROTECTION_HOVER_OUTSIDE = 200
export const DELAY_SUB_BRANDS = 40
